import { defineStore } from 'pinia';
import ShopApi from '~/lib/shop-api';
import type { Order } from '~/lib/types/order';

export interface OrderState {
  order: Order | undefined;
}

export const useOrderStore = defineStore('order', {
  state: (): OrderState => ({
    order: undefined,
  }),

  getters: {
    confirmedItems(state) {
      return state.order?.items || [];
    },
    confirmedOrder(state) {
      if (!state.order) return {};
      return state.order;
    },
  },

  actions: {
    setOrder(order: Order) {
      this.order = order;
    },
    async submitOrder(orderParams: any) {
      return ShopApi.submitOrder(orderParams);
    },
    async submitPaypalExpressOrder(orderParams: any) {
      return ShopApi.submitPaypalExpress(orderParams);
    },
    async setConfirmedOrder() {
      const data = await ShopApi.confirmOrder();
      this.setOrder(data.order);
      return data;
    },
  },
});
